module.exports = __webpack_public_path__ + "static/ciggy-dd716432be07b5d9ba84359efb38de36.jpg";